import { createAsyncThunk } from "@reduxjs/toolkit";
import { deletePost } from "../../../pages/auth/utils/firebase/userOperations";

export const removePost = createAsyncThunk(
  "posts/removePost",
  async ({ postId, userId }, { rejectWithValue }) => {
    try {
      await deletePost(postId, userId);
      return postId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
